import { QueryFilterOperator } from '../utils/query-const';

export const ValidationErrorMessage = {
    DATA_PROVIDER_NOT_FOUND: ({ name }) => `провайдер данных "${name}" отсутствует`,
    DATASET_PROPS_NAME_REQUIRED: 'Источник не добавлен – отсутствует название',
    DATASET_PROPS_NAME_TOO_LONG: 'Источник не добавлен – название слишком длинное'
}

export const ToastMessage = {
    ERROR_OCCURED: () => 'Произошла ошибка',
    DATA_PROVIDER_CHANGED: ({ name }) => `Провайдер данных изменен: ${name}`,
    IMPORTED_SUCCESSFULLY: () => 'Успешно импортировано',
    DATASET_PROPS_UPDATED: ({ name }) => `Источник "${name}" успешно изменен`,
    DATASET_PROPS_ADDED: ({ name }) => `Источник "${name}" успешно добавлен`,
    DATASET_PROPS_IMPORTED_WITH_ERRORS: ({ name, error }) => `Источник "${name}" добавлен с ошибкой – ${error}`,
    DATASETS_PROPS_ORDER_CHANGED: () => `Порядок источников изменен`,
    DATASET_PROPS_DELETED: ({ name }) => `Источник "${name}" удален`,
    DATASET_PROPS_REPLACED: ({ oldName, newName  }) => `Источник "${oldName}" перезаписан на "${newName}"`,
    IMPORT_FROM_CLIPBOARD_JSON_EQUAL: () => `Источник не перезаписан – настройки полностью совпадают`,
    IMPORT_FROM_CLIPBOARD_INVALID_JSON: () => 'Источник не добавлен – импортируемое содержимое не является JSON',
    IMPORT_FROM_CLIPBOARD_INVALID_SCHEMA: () => 'Источник не добавлен – JSON имеет неверный формат',
    DATASET_PROPS_COPIED: ({ name }) => `JSON источника "${name}" скопирован`,
    PREVIEW_SQL_COPIED: () => `SQL скопирован`
};

export const QueryFilterOperatorPlaceholder = {
    [QueryFilterOperator.EQ]: (str) => [str],
    [QueryFilterOperator.EQ_NOT]: (str) => [str],
    [QueryFilterOperator.IS]: (str) => [str],
    [QueryFilterOperator.IS_NOT]: (str) => [str],
    [QueryFilterOperator.LESS]: (str) => [str],
    [QueryFilterOperator.LESS_EQ]: (str) => [str],
    [QueryFilterOperator.GREATER]: (str) => [str],
    [QueryFilterOperator.GREATER_EQ]: (str) => [str],
    [QueryFilterOperator.IN]: (str) => [str, str, str],
    [QueryFilterOperator.IN_NOT]: (str) => [str, str, str],
    [QueryFilterOperator.BETWEEN]: (str) => [str, str],
    [QueryFilterOperator.BETWEEN_NOT]: (str) => [str, str],
    [QueryFilterOperator.LIKE]: (str) => [str]
};

export const EntityType = {
    METRIC: 'metric',
    DIMENSION: 'dimension',
    DRILLDOWN: 'drilldown',
    FIELD: 'field',
    VARIABLE: 'variable',
    FILTER: 'filter',
    SORT: 'sort'
};

export const EntityTypeMeta = {
    [EntityType.METRIC]: { icon: 'mdi-gauge' },
    [EntityType.DIMENSION]: { icon: 'mdi-axis-arrow' },
    [EntityType.DRILLDOWN]: { icon: 'mdi-layers-outline' }
};

export const DATASET_REQUEST_PROPS_NAME_MAX_LENGTH = 128;
